import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import MailIcon from "@redotech/redo-web/icon-old/mail.svg";
import { produce } from "immer";
import * as React from "react";
import {
  StepDownstream,
  StepId,
  StepType,
  StepTypeDetailsProps,
} from "../step";
import { containsImg } from "./step-rich-text-util";

export interface SendMessageState {
  next: StepId | undefined;
  message: string;
  messageHtml?: string;
  attempted?: boolean;
  customTitle?: string;
}

export const SEND_MESSAGE = (
  Details: React.ComponentType<StepTypeDetailsProps<SendMessageState>>,
): StepType<SendMessageState, ModelStep.SendMessage> => ({
  Details: (props: StepTypeDetailsProps<SendMessageState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Send message",
  valid(state) {
    return (
      state.next !== undefined &&
      !!state.message &&
      !containsImg(state.messageHtml)
    );
  },
  Icon: MailIcon,
  description(state) {
    return state.message;
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  layout() {
    return BlockLayout.FULL;
  },
  empty: { message: "", next: undefined, messageHtml: undefined },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SEND_MESSAGE,
      next: id(state.next!),
      message: state.message,
      messageHtml: state.messageHtml,
    };
  },
  fromModel(model, id) {
    return {
      customTitle: model.customTitle,
      next: id(model.next),
      message: model.message,
      messageHtml: model.messageHtml,
    };
  },
});
